package com.partejar.app.core.format

import kotlin.math.roundToLong

internal fun formatBrazilianCents(cents: Long): String {
    val integer = (cents / 100).toString().reversed().chunked(3).joinToString(".").reversed()
    return "$integer,${(cents % 100).toString().padStart(2, '0')}"
}

internal fun formatBrazilianCurrency(value: Double): String = "R$ ${formatBrazilianCents((value * 100).roundToLong())}"

internal fun priceToDigits(value: Double): String = (value * 100).roundToLong().toString()

internal fun centsDigitsToDecimal(digits: String): String? {
    if (digits.isEmpty() || digits.any { it !in '0'..'9' }) return null
    val cents = digits.toLongOrNull() ?: return null
    return "${cents / 100}.${(cents % 100).toString().padStart(2, '0')}"
}
